import React from 'react';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { COMPANY_CREATE_INSTRUCTION, COMPANY_MENU_INSTRUCTION_SHORT } from '../../utils/companySelectionHelp';

/**
 * Shown when the user is on Control Bridge routes but no company is selected (empty tenant).
 */
export const ControlBridgeCompanyRequired: React.FC = () => {
  const { selectedCompany, isAuthenticated, availableCompanies } = useUser();
  const navigate = useNavigate();

  if (!isAuthenticated || selectedCompany) {
    return null;
  }

  if (availableCompanies.length === 0) {
    return (
      <Alert
        type="warning"
        showIcon
        style={{ margin: '0 24px 16px' }}
        message="No company linked yet"
        description={
          <>
            <p style={{ marginBottom: 8 }}>{COMPANY_CREATE_INSTRUCTION}</p>
            <Button type="primary" size="small" onClick={() => navigate('/register')}>
              Create company
            </Button>
          </>
        }
      />
    );
  }

  return (
    <Alert
      type="info"
      showIcon
      style={{ margin: '0 24px 16px' }}
      message="Select a company"
      description={COMPANY_MENU_INSTRUCTION_SHORT}
    />
  );
};
